import React, { createContext, useCallback, useContext, useState } from 'react';

// Preferência de tela, não de conta: fica no navegador, não no backend. Sobrevive a logout de
// propósito (o AuthContext só remove 'user' e 'token'), porque é o mesmo comportamento que faz
// sentido continuar no re-login, no mesmo navegador.
const STORAGE_KEY = 'stackfy.balances_hidden';

const lerPreferencia = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

const BalanceVisibilityContext = createContext(undefined);

// useState com inicializador roda antes do primeiro paint, então a tela nunca chega a desenhar um
// valor real para depois trocar por máscara — não existe efeito nem flash aqui.
export const BalanceVisibilityProvider = ({ children }) => {
  const [hidden, setHidden] = useState(lerPreferencia);

  const toggle = useCallback(() => {
    setHidden((atual) => {
      const proximo = !atual;
      try {
        localStorage.setItem(STORAGE_KEY, proximo ? '1' : '0');
      } catch {
        // localStorage indisponível (modo privado, quota etc.): a preferência só não persiste.
      }
      return proximo;
    });
  }, []);

  return (
    <BalanceVisibilityContext.Provider value={{ hidden, toggle }}>
      {children}
    </BalanceVisibilityContext.Provider>
  );
};

export const useBalanceVisibility = () => {
  const context = useContext(BalanceVisibilityContext);
  if (!context) {
    throw new Error('useBalanceVisibility precisa de um BalanceVisibilityProvider por perto');
  }
  return context;
};
